module.exports = __webpack_public_path__ + "img/report-icon.c896f3d8.gif";